import PropTypes from 'prop-types';

import { useClipboard } from '../hooks';

import './styles/buttonStyles.css';

const typeStyles = {
  primary: 'button-primary',
  secondary: 'button-secondary',
  subtle: 'button-subtle',
  tertiary: 'button-tertiary',
};

const ClipboardButton = ({
  children,
  clipboardOptions,
  clipboardText,
  type,
  ...rest
}) => {
  const [isCopied, setIsCopied] = useClipboard(clipboardText, clipboardOptions);

  const getChildContent = () => {
    const props = {
      isCopied,
    };

    if (typeof children === 'function') {
      return children(props);
    }

    return children;
  };

  return (
    <button
      className={typeStyles[type] || ''}
      onClick={setIsCopied}
      type="button"
      {...rest}
    >
      {getChildContent()}
    </button>
  );
};

ClipboardButton.defaultProps = {
  clipboardOptions: {},
  clipboardText: '',
  type: 'primary',
};

ClipboardButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  clipboardOptions: PropTypes.shape({
    duration: PropTypes.number,
  }),
  clipboardText: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'secondary', 'subtle', 'tertiary']),
};

export default ClipboardButton;
